"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion4toVersion5 = void 0;
const updateVersion4toVersion5 = (configuration) => {
    return Object.assign(Object.assign({}, configuration), { version: 5, main: Object.assign(Object.assign({}, configuration.main), { buttons: configuration.main.buttons.map(button => {
                return Object.assign(Object.assign({}, button), { isVisible: !!(button.text && button.url) });
            }) }), footer: Object.assign(Object.assign({}, configuration.footer), { privacyPolicy: Object.assign(Object.assign({}, configuration.footer.privacyPolicy), { isVisible: !!(configuration.footer.privacyPolicy.url && configuration.footer.privacyPolicy.text) }) }) });
};
exports.updateVersion4toVersion5 = updateVersion4toVersion5;
//# sourceMappingURL=v5.js.map